<template>
    <div class="download" v-if="!!src">
        <i class="fas fa-spinner fa-spin" v-if="downloading"></i>
        <i class="fas fa-download" v-else @click="downloadFile"></i>
    </div>
</template>

<script>
    import { API_URL } from '@/common/config'

    export default {
        name: 'Download',
        props: {
            src: {
                type: String,
                required: true
            }
        },
        data () {
          return {
              downloading: false
          }
        },
        methods: {
            async downloadFile () {
                this.downloading = true
                const fileLink = document.createElement('a')
                fileLink.href = `${API_URL}/file/download?file=${encodeURIComponent(this.src)}`
                document.body.appendChild(fileLink)
                fileLink.click()
                document.body.removeChild(fileLink)
                this.downloading = false
            }
        }
    }
</script>

<style scoped>
    .download {
        cursor: pointer;
        font-size: 16px;
    }
</style>
